import type { NetworkParams } from './types'

export const match = (hostname: string): boolean => /7tiv\.net|w2t6\.net/.test(hostname)
export const compactTracking = true

export const apply = (url: URL, params: NetworkParams): void => {
  if (params.trackingId) {
    url.searchParams.set('sid', params.trackingId)
    return
  }
  if (params.content) {
    url.searchParams.set('sid', `co=${params.content}|${params.utmSearch}|t=${params.term}`)
  } else {
    url.searchParams.set('sid', `${params.utmSearch}|t=${params.term}`)
  }
}
